import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import APRPromoPopup from './APRPromoPopup';
import { articlesApi } from '../lib/api';

// CRO Audit §3.3 #3 — affiliate promo offers belong in CONTEXTUAL in-content
// blocks on relevant articles, NOT as an app-wide modal. This gate restricts
// APRPromoPopup to peptide-context routes only:
//   - /peptides  (the hub)
//   - /blog?category=Peptides
//   - /blogs/article/<slug>  where the article is in the Peptides category
//
// Anywhere else (homepage, /tools, /hyrox, /checkout, etc.) the popup is suppressed.
const PEPTIDE_PATH_PATTERNS = [
  /^\/peptides(\/|$)/i,
];

const isPeptideRoute = (path, search) => {
  if (PEPTIDE_PATH_PATTERNS.some(re => re.test(path))) return true;
  if (path === '/blog' && /category=peptides/i.test(search || '')) return true;
  return false;
};

export const APRPromoPopupGate = () => {
  const location = useLocation();
  const [allowedByArticle, setAllowedByArticle] = useState(false);

  // For article pages, fetch the article and check category.
  useEffect(() => {
    const m = location.pathname.match(/^\/blogs\/article\/([^/]+)/);
    if (!m) {
      setAllowedByArticle(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await articlesApi.getBySlug(m[1]);
        const a = res?.data;
        if (cancelled) return;
        const cat = (a?.category || '').toLowerCase();
        const tags = (a?.tags || []).map(t => (t || '').toLowerCase());
        const peptideTags = ['peptide', 'bpc-157', 'aod-9604', 'dihexa', 'ghk-cu', 'mk-677', 'retatrutide', 'tb-500', 'mots-c', 'kpv', 'semaglutide'];
        setAllowedByArticle(cat === 'peptides' || tags.some(t => peptideTags.includes(t)));
      } catch (err) {
        if (!cancelled) {
          console.error('APR promo article fetch failed:', err);
          setAllowedByArticle(false);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [location.pathname]);

  const allowed = isPeptideRoute(location.pathname, location.search) || allowedByArticle;
  if (!allowed) return null;
  return <APRPromoPopup />;
};

export default APRPromoPopupGate;
